import { combineEpics, ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { REQUEST } from './actionType';
import { AnyAction } from 'redux';

const requestsEpic = (action$: Observable<AnyAction>) =>
  action$.pipe(
    ofType(REQUEST),
    map(({ payload: { type, payload } }) => {
      return {
        type,
        payload,
      };
    }),
  );

export default combineEpics(requestsEpic);
